module.exports = __webpack_public_path__ + "img/helper_template.b9b71b55.png";